import React from 'react';
import { FaWhatsapp } from 'react-icons/fa6';

const WhatsAppButton = () => {
  return (
    <a
      href="https://api.whatsapp.com/send/?phone=919106982981&text=Hello+TrioPerspective%21%0AI+am+interested+in+your+Amazon+services.+Please+contact+me%21&type=phone_number&app_absent=0"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 bg-[#25D366] text-white p-3 rounded-full shadow-lg hover:bg-[#128C7E] transition-colors duration-300 z-50"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp className="w-10 h-10" />
    </a>
  );
};

export default WhatsAppButton;
